<div class="markdown-html">
	<div class="center-content">{{ 'workflow.test.completed' | translate }}</div>
	<div class="tab-centered" *ngIf="(workflowItemKey.property$ | async) as values">
		<table>
			<thead>
				<tr>
					<th></th>
					<th></th>
					<th class="right-align cell-padding pl-4">{{ 'workflow.test.labyrinth.labyrinth' | translate:{'num': 'word.num.first' | translate} }}</th>
					<th class="right-align cell-padding pl-4">{{ 'workflow.test.labyrinth.labyrinth' | translate:{'num': 'word.num.second' | translate} }}</th>
					<th class="right-align pl-4">{{ 'workflow.test.labyrinth.labyrinth' | translate:{'num': 'word.num.third' | translate} }}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td class="left-align">{{ 'word.time' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<!-- Tested == null statt === null weil es auch auf undefined true ergibt und somit ähnlich isNil ist -->
					<td class="right-align cell-padding" *ngIf="values[0]?.zeit != null">{{ values[0].zeit | number:'1.2-2' }}
						{{ 'unit.seconds.short' | translate }}</td>
					<td class="right-align cell-padding" *ngIf="values[0]?.zeit == null">- {{ 'unit.seconds.short' | translate }}</td>
					<td class="right-align cell-padding" *ngIf="values[1]?.zeit != null">{{ values[1].zeit | number:'1.2-2' }}
						{{ 'unit.seconds.short' | translate }}</td>
					<td class="right-align cell-padding" *ngIf="values[1]?.zeit == null">- {{ 'unit.seconds.short' | translate }}</td>
					<td class="right-align cell-padding" *ngIf="values[2]?.zeit != null">{{ values[2].zeit | number:'1.2-2' }}
						{{ 'unit.seconds.short' | translate }}</td>
					<td class="right-align cell-padding" *ngIf="values[2]?.zeit == null">- {{ 'unit.seconds.short' | translate }}</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'workflow.test.labyrinth.repetitiveErrors' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[0]?.wiederholungsfehler }}</td>
					<td class="right-align cell-padding">{{ values[1]?.wiederholungsfehler }}</td>
					<td class="right-align">{{ values[2]?.wiederholungsfehler }}</td>
				</tr>
				<tr>
					<td class="left-align">{{ 'workflow.test.labyrinth.trialMistake' | translate }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[0]?.probefehler }}</td>
					<td class="right-align cell-padding">{{ values[1]?.probefehler }}</td>
					<td class="right-align">{{ values[2]?.probefehler }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
